import React from "react";

import { ENV } from "../../env";

export type ZeosEnvironmentType = "local" | "dev" | "qa" | "demo" | "prod";

export const isZeosEnvironment = (environment: ZeosEnvironmentType) => {
  return ENV.ENVIRONMENT === environment;
};

export const isZeosEnvironments = (enviroments: ZeosEnvironmentType[]) => {
  const match = enviroments.includes(ENV.ENVIRONMENT as ZeosEnvironmentType);
  return match;
};

export const isDemo = () => isZeosEnvironment("demo");

export const ZeosLocalModeWarning = () => ZeosEnvironmentWarning("local");

export const ZeosDemoModeWarning = () => ZeosEnvironmentWarning("demo");

export const ZeosQaModeWarning = () => ZeosEnvironmentWarning("qa");

export const ZeosEnvironmentWarning = (environment: ZeosEnvironmentType) => {
  if (isZeosEnvironment(environment)) {
    return <div className="text-red-500 font-bold text-lg">{environment}</div>;
  } else return <></>;
};

export type EmailWhiteListReturn = {
  success: boolean;
  message: string;
};

const normalizeEmail = (email: string): string => {
  const trimmed = email.trim().toLowerCase();
  const [rawLocal, rawDomain] = trimmed.split("@");
  if (!rawLocal || !rawDomain) return trimmed;

  const domain = rawDomain === "googlemail.com" ? "gmail.com" : rawDomain;

  if (domain === "gmail.com") {
    const localBeforePlus = rawLocal.split("+")[0];
    const local = localBeforePlus.replace(/\./g, "");
    return `${local}@${domain}`;
  }

  return `${rawLocal}@${domain}`;
};

export const getZeosEmailDomains = (): string[] => {
  const domains = ENV.EMAIL_DOMAINS;
  if (!domains) return [];
  return domains.split(",").map((d: string) => d.trim().toLowerCase());
};

export const getZeosEmailAllowList = (): string[] => {
  const allowList = ENV.EMAIL_ALLOWLIST;
  if (!allowList) return [];
  return allowList.split(",").map((email: string) => email.trim().toLowerCase());
};

const isAllowlistedEmail = (email: string): boolean => {
  const allowList = getZeosEmailAllowList();
  if (allowList.length === 0) return false;
  const normalizedEmail = normalizeEmail(email);
  return allowList.some((entry) => normalizeEmail(entry) === normalizedEmail);
};

export const handleZeosEnviromentEmailWhitelist = (
  email: string
): EmailWhiteListReturn => {
  if (!isValidEmail(email)) {
    return { success: false, message: "Invalid email format." };
  }

  if (isAllowlistedEmail(email)) {
    return { success: true, message: "" };
  }

  const emailDomain = email.split("@").pop()?.toLowerCase() || "";
  const domainsArray = getZeosEmailDomains();
  const isWildCard = domainsArray.length == 1 && domainsArray.includes("*");
  if (domainsArray.includes(emailDomain) || isWildCard) {
    return { success: true, message: "" };
  } else {
    return {
      success: false,
      message: `Invalid domain for ${
        ENV.ENVIRONMENT
      }.\nAcceptable domains: ${domainsArray.join(", ")}.\nExample.com can be used but no email will be delivered.`,
    };
  }
};

export const ZeosLocalMode = () => {
  if (isZeosEnvironment("local")) {
    return <div className="text-red-500 font-bold text-lg">LOCAL MODE</div>;
  } else return <></>;
};

export const isValidEmail = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
